import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 456 456"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#512BD4",
      d: "M0 0h456v456H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M81.274 291.333q-4.836 0-8.222-3.223-3.386-3.306-3.386-7.851 0-4.629 3.386-7.934t8.222-3.306q4.917 0 8.302 3.306 3.466 3.305 3.466 7.934 0 4.545-3.466 7.851-3.385 3.223-8.302 3.223M210.167 289.515h-20.958l-55.215-87.109a39 39 0 0 1-3.466-6.86h-.484q.645 3.802.645 16.281v77.688h-18.54V171h22.328l53.362 85.043q3.385 5.29 4.353 7.273h.322q-.806-4.71-.806-15.951V171h18.459zM300.449 289.515h-64.888V171h62.309v16.695h-43.124v33.554h39.739v16.612h-39.739v35.042h45.703zM392.667 187.695h-33.21v101.82h-19.185v-101.82h-33.129V171h85.524z"
    }, null, -1)
  ])))
}
export default { render: render }